import { inject, Injectable } from '@angular/core';

import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN } from '@core/common-legacy';
import type { HttpApiRequestOptions, IdentityHeaders } from '@core/http-types';
import { HttpRequestData } from '@core/http-types';
import { injectReportsAppKind, injectReportsCompanyId } from '@core/reports-contracts';
import { TellentReportsEnvironment } from '@core/reports-types';

@Injectable()
export class ReportsRequestData extends HttpRequestData {
  protected config = inject<TellentReportsEnvironment>(APP_CONFIG);

  private authMethod = inject(AUTH_METHOD);
  private authToken = inject(AUTH_TOKEN);
  private companyId = injectReportsCompanyId();
  private appKind = injectReportsAppKind();

  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.reportsApiUrl}/${this.appKind}/c/${this.companyId}${path}`;
  }

  public provideAuthHeaders(): { Authorization: string } {
    return { Authorization: `${this.authMethod} ${this.authToken}` };
  }

  public provideIdentityHeaders(): IdentityHeaders {
    // TODO - ask the team if it's necessary
    return {};
  }
}
